import ajax from '@/utils/ajax';
import
{
  PAGELIST,
  DELETEMSG,
  DELETEBATCH,

} from '@/assets/js/messageList';

const header = '/web';

export const pageList = (data) => ajax(`${header}${PAGELIST}`, data, 'GET');// 获取

export const deleteMsg = (data) => ajax(`${header}${DELETEMSG}${data}`, {}, 'DELETE');// 删除

export const deleteBatch = (data) => ajax(`${header}${DELETEBATCH}`, data, 'DELETE');// 批量删除
